import { Media } from '@adeo/ngx-kozikaza-api/kazaplan';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input
} from '@angular/core';

@Component({
  selector: 'app-kazaplan-diaporama',
  templateUrl: './kazaplan-diaporama.component.html',
  styleUrls: ['./kazaplan-diaporama.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class KazaplanDiaporamaComponent {

  private _medias: Media[] = [];
  public planMediaLoaded: boolean[] = [];

  @Input()
  set medias(val) {
    if (this._medias !== val) {
      this.cdr.markForCheck();
    }
    this._medias = val;
    this.planMediaLoaded = [...Array(this._medias.length).fill(false)];
  }

  get medias() {
    return this._medias;
  }

  public diapoCurrentMedia = 0;

  constructor(
    protected cdr: ChangeDetectorRef,
  ) {
  }

  public nextMedia(event: any) {
    event.stopPropagation();
    this.diapoCurrentMedia = (this.diapoCurrentMedia === (this.medias.length - 1)) ? 0 : this.diapoCurrentMedia + 1;
    this.cdr.detectChanges();
  }
  public previousMedia(event: any) {
    event.stopPropagation();
    this.diapoCurrentMedia = (this.diapoCurrentMedia === 0) ? (this.medias.length - 1) : this.diapoCurrentMedia - 1;
    this.cdr.detectChanges();
  }

  public trackMedia(index: number, item: Media): string {
    return (!item) ? null : item.id;
  }

}
